var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 16.6666L7.50016 12.5M3.92275 8.92255L11.0776 16.0774C11.3204 16.3202 11.7361 16.1816 11.7847 15.8417L12.4216 11.3833C12.4726 11.0263 12.638 10.6955 12.893 10.4405L14.512 8.82145C14.8246 8.50889 15.2485 8.33329 15.6905 8.33329H16.4942C16.8655 8.33329 17.0514 7.88448 16.7889 7.622L12.3781 3.21125C12.1156 2.94877 11.6668 3.13467 11.6668 3.50588V4.3096C11.6668 4.75163 11.4912 5.17555 11.1787 5.48811L9.55967 7.10712C9.30467 7.36212 8.97385 7.52753 8.61686 7.57853L4.15845 8.21544C3.81855 8.264 3.67997 8.67976 3.92275 8.92255Z",
    stroke: "#026735",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectStatus);
export default __webpack_public_path__ + "static/media/projectStatus.beca8f34c5dd04f426e3063314275fc7.svg";
export { ForwardRef as ReactComponent };